/**
 * draft 재편집 성능(draft-body-style-from-viewer): 뷰어가 draft 본문을 표시하려고 이미 수행한
 * DOMParser 파싱 결과에서, 에디터 defaultStyle 시딩(parseBodyDefaultStyle)이 읽는 요소들만
 * **얕은 클론 골격**(수백 바이트)으로 추출한다. host 는 이 골격을 보관했다가 draft 편집 열기 시
 * 본문 2.7MB 전체 재파싱 대신 골격만 파싱해 동일한 스타일을 얻는다.
 *
 * parseBodyDefaultStyle 이 읽는 것은 ①`<body nine-mail-id>` 의 속성(style 등) ②legacy
 * `div[nine-mail-id]`(비-region 첫 번째)의 속성뿐이다. 골격은 body 얕은 클론 안에 모든
 * `div[nine-mail-id]` 얕은 클론을 **문서 순서대로** 담아, 두 분기 판정(속성·class·순서)을
 * 원본과 동일하게 재현한다. 자식이 없으므로 스타일 외 데이터는 포함되지 않는다.
 *
 * 호출 시점: applyBodyElem 의 parseFromString 직후, 본문 mutate(이미지 src 치환/인용 제거) **전**
 * — 원형 기준 추출이어야 에디터 쪽 전체 파싱과 결과가 동일하다.
 */
export function buildDraftBodyStyleSkeleton(doc: Document): string {
  const body = doc.body
  if (body == null) return ''
  const skeleton = body.cloneNode(false) as HTMLElement
  doc.querySelectorAll('div[nine-mail-id]').forEach((div) => {
    skeleton.appendChild(div.cloneNode(false))
  })
  return skeleton.outerHTML
}
